import Component from "../../../../js/assets/component.js"
import SlideShowItem from "../../organisms/lp/slideshow_item.js"

class SmallSlideshow extends Component {
  constructor(el){
    super(el)
  }

  data(){
    return {
      "loaded_count": 0,
      "loading": false,
      "loaded": false,
      "activeIndex": null
    }
  }

  changed(){
    return {
      "loaded_count": (val)=>{
        if(val >= this.thumbs.length){
          this.$data.loaded = true
          this.noChange("loaded_count")
        }
      },
      "loading": (val)=>{
        if(val===true){
          this.$loading.removeClass("-inActive")
          this.$loading.addClass("-active")
        }else{
          this.$loading.removeClass("-active")
          this.$loading.addClass("-inActive")
        }
      },
      "loaded": (val)=>{
        if(val === true){
          this.noChange("loaded")
          //スライド可能にして1枚目を表示する
          this.canChange("activeIndex")
          this.$data.activeIndex = 0
        }
      },
      "activeIndex": async(index, prev) => {
        this.noChange("activeIndex")
        this.$data.loading = true
        //画像読み込み完了するまで待機
        await this.loadImage(index)
        this.swapZoomImage(index)
        this.swapThumbnail(index)
        this.$data.loading = false
        this.canChange("activeIndex")
      }
    }
  }

  async loadImage(index){
    if(this.slideshowItem[index].$data.loading === false){
      this.$data.loading = true
      await this.slideshowItem[index].load()
    }else if(this.slideshowItem[index].$data.loaded === false){
      this.$data.loading = true
      await this.slideshowItem[index].waitLoaded()
    }
  }

  swapZoomImage(index){
    for(let i=0; i<this.slideshowItem.length; i++){
      if(i === index){
        this.slideshowItem[i].activate()
      }else{
        this.slideshowItem[i].inActivate()
      }
    }
  }

  swapThumbnail(index){
    for(let i=0; i<this.thumbs.length; i++){
      if(i === index){
        this.thumbs[i].activate()
      }else{
        this.thumbs[i].inActivate()
      }
    }
  }

  /*
  *  サムネ画像を全て読み込む
  */
  async loadImages(){
    if(!this.thumbs){
      return
    }
    //サムネ画像が無い（スライドショー画像が1枚の場合は読み込み完了にする）
    else if(this.thumbs.length === 0){
      this.$data.loaded_count += 1
      return
    }
    for(let i=0; i<this.thumbs.length; i++){
      this.thumbs[i].addEventListener("loaded", ()=>{
        //読み込み完了したらカウントを+1
        this.$data.loaded_count += 1
      })
      this.thumbs[i].load()
    }
  }

  mounted() {
    var self = this

    //画像の読み込みが完了するまでスライドショーを機能させない
    this.noChange("activeIndex")

    //loading
    this.$loading = this.$el.find(".loading")
    this.$loading.addClass("-active")

    //thumbnail
    this.thumbs = []
    this.$el.find("li.smallSlideShow_thumbItem").each(function(i){
      self.thumbs[i] = new SlideShowItem($(this))
      self.thumbs[i].$data.renderType = "bg"
      self.thumbs[i].registerImage($(this).attr("data-image"))
    })
    for(let i=0; i<this.thumbs.length; i++){
      this.thumbs[i].$el.on("click", ()=>{
        this.$data.activeIndex = i
      })
    }
    //zoomImage
    this.slideshowItem = []
    this.$el.find(".smallSlideShow_item").each(function(i){
      self.slideshowItem[i] = new SlideShowItem($(this))
      self.slideshowItem[i].$data.renderType = "img"
      self.slideshowItem[i].registerImage($(this).attr("data-image"))
    })
  }
}

export default SmallSlideshow
